(function () {
    'use strict';
    /*
     * Copyright (c) 2018 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('RtcService', RtcService);

    RtcService.$inject = [];

    /**
     * A service to manage WebRTC connection.
     * @ngdoc service
     * @name RtcService
     * @memberOf ihh-common-web
     */
    function RtcService() {
        /**
         * Initiates a WebRTC call.
         *
         * @param {String} myId a unique ID of the caller; used to ignore its own signals
         * @param {Object[]} iceServers an array of ICE server records
         * @param {Function} sendSignal a callback to send a signal
         * @param {Function} getSignals a callback to get all the signals sent for the call
         * @param {Object} localStream the local stream of the video chat
         * @param {Function} onRemoteStream a callback that returns the remote stream when the connection is made
         * @returns {RtcConnection} the RTC connection created
         */
        this.startCall = function(myId, iceServers, sendSignal, getSignals, localStream, onRemoteStream) {
            return new RtcConnection(myId, true, iceServers, sendSignal, getSignals, localStream, onRemoteStream);
        };

        /**
         * Accepts a WebRTC call.
         *
         * @param {String} myId a unique ID of the caller; used to ignore its own signals
         * @param {Object[]} iceServers an array of ICE server records
         * @param {Function} sendSignal a callback to send a signal
         * @param {Function} getSignals a callback to get all the signals sent for the call
         * @param {Object} localStream the local stream of the video chat
         * @param {Function} onRemoteStream a callback that returns the remote stream when the connection is made
         * @returns {RtcConnection} the RTC connection created
         */
        this.answerCall = function(myId, iceServers, sendSignal, getSignals, localStream, onRemoteStream) {
            return new RtcConnection(myId, false, iceServers, sendSignal, getSignals, localStream, onRemoteStream);
        };

        function RtcConnection(myId, isCalling, iceServers, sendSignal, getSignals, localStream, onRemoteStream) {
            console.log('Creating RtcConnection');

            var pollingTimer = null;

            var connecting = true;
            var handledSignalIds = [];
            var queuedCandidates = [];

            var connection = new RTCPeerConnection({
                'iceServers': iceServers
            });

            connection.onicecandidate = onIceCandidate;
            connection.onaddstream = onAddStream;
            connection.addStream(localStream);

            if (isCalling) {
                console.log('createOffer');
                connection.createOffer(onGotDescription, onError);
            }

            pollSignals();

            this.close = close;

            function close() {
                if (pollingTimer) {
                    clearTimeout(pollingTimer);
                    pollingTimer = null;
                }

                if (connection) {
                    connection.close();
                    connection = null;
                }
            }

            function pollSignals() {
                if (connecting) {
                    getSignals().then(handleSignals, onError);
                }
            }

            function onIceCandidate(event) {
                console.log('onIceCandidate: ' + event.candidate);
                if (event.candidate !== null) {
                    sendSignal({
                        senderId: myId,
                        type: 'candidate',
                        data: JSON.stringify(event.candidate)
                    });
                }
            }

            function onAddStream(event) {
                console.log('onAddStream: ' + event);
                connecting = false;
                onRemoteStream(event.stream);
            }

            function onGotDescription(description) {
                console.log('onGotDescription: ' + description);

                connection.setLocalDescription(description, function() {
                    sendLocalDescription(description);
                }, function () {
                    onError('Error setting local description');
                });
            }

            function sendLocalDescription(description) {
                console.log('sendLocalDescription: ' + description);

                sendSignal({
                    senderId: myId,
                    type: 'description',
                    data: JSON.stringify(description)
                });
            }

            function onError(error) {
                console.log('onError: ' + error);
            }

            function handleSignals(signals) {
                console.log('handleSignals');
                for (var i = 0; i < signals.length; i++) {
                    var signal = signals[i];
                    if (handledSignalIds.indexOf(signal.id) === -1) {
                        console.log('Got a new signal ' + signal.id + ' from ' + signal.senderId);
                        handledSignalIds.push(signal.id);

                        if (signal.senderId !== myId) {
                            console.log('Got someone else signal ' + signal.id + ' from ' + signal.senderId);
                            if (signal.type === 'candidate') {
                                console.log('Got candidate signal ' + signal.id + ' from ' + signal.senderId);
                                var candidate = JSON.parse(signal.data);

                                if (connection && connection.remoteConnection && connection.remoteConnection.type) {
                                    connection.addIceCandidate(new RTCIceCandidate(candidate));
                                }
                                else {
                                    queuedCandidates.push(candidate);
                                }
                            }
                            else if (signal.type === 'description') {
                                console.log('Got description signal ' + signal.id + ' from ' + signal.senderId);
                                var description = JSON.parse(signal.data);
                                connection.setRemoteDescription(new RTCSessionDescription(description), function() {
                                    if (description.type === 'offer') {
                                        connection.createAnswer(onGotDescription, onError);
                                    }
                                });

                                for (var i = 0; i < queuedCandidates.length; i++) {
                                    connection.addIceCandidate(new RTCIceCandidate(queuedCandidates[i]));
                                }
                            }
                        }
                    }
                }

                if (connecting) {
                    pollingTimer = setTimeout(pollSignals, 3000);
                }
            }
        }
    }
})();